import BaseElement from './BaseElement';
import HealthscoreReportDetail from '../Components/Profile/HealthscoreReportDetail';
class HealthscoreReportDetailElement extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = HealthscoreReportDetail;
    }
}
export const loadHealthscoreReportDetailElement = () => {
    customElements.define('healthscore-report-detail', HealthscoreReportDetailElement);
};
